import React from 'react';
import MenuItem from '@mui/material/MenuItem';
import Button from 'components/atoms/Button';
import { EButtonSizesPX, EButtonVariants } from 'constants/Buttons';
import { EIconTypes } from 'constants/Icons';
import ListItemIcon from '@mui/material/ListItemIcon';
import Icon from 'components/atoms/Icon/Icon';
import ListItemText from '@mui/material/ListItemText';
import { colors } from 'theme/colors';
import { StyledMenu } from './styles';

export interface IMenuButtonItem {
  name: string;
  icon?: EIconTypes;
  handler: () => void;
  disabled?: boolean;
}

interface IMenuButton {
  items: IMenuButtonItem[];
  id: string;
}

const MenuButton = ({ items, id }: IMenuButton) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        variant={EButtonVariants.outlined}
        sizePX={EButtonSizesPX.px24}
        tableButton={true}
        icon={EIconTypes.moreVert}
        id={`menuButton-button-${id}`}
        onClick={handleClick}
      />
      <StyledMenu
        id={`menuButton-menu-${id}`}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {items.map((item) => (
          <MenuItem
            disabled={item?.disabled}
            onClick={() => {
              item.handler();
              handleClose();
            }}
          >
            {item?.icon && (
              <ListItemIcon>
                <Icon type={item.icon} color={colors.black} fontSize={16} />
              </ListItemIcon>
            )}
            <ListItemText>{item.name}</ListItemText>
          </MenuItem>
        ))}
      </StyledMenu>
    </>
  );
};

export { MenuButton };
